import React from "react";
import BusinessBodyCard from "./BusinessBodyCard";
import styled, { keyframes } from "styled-components";
import useSWR from "swr";
import { useTheme } from "@mui/material/styles";

import bImg8 from "../../Assets/Images/Icons/businessIcon8.png";

import { getForBusinessCardByPartner } from "../../api/axios";

export default function BusinessBodySection() {
  const theme = useTheme();

  const { data: data = [] } = useSWR(
    `getForBusinessCard`,
    async () => {
      try {
        const { data } = await getForBusinessCardByPartner();
        const cardData = data.data[0];
        return { ...cardData, index: data.data.indexOf(cardData) };
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  return (
    <BusinessBodyCardContainer>
      <div className="BusinessBodyCard">
        <BusinessBodyCard
          color={`${theme.palette.primary.main}`}
          image={data.card_image1}
          text={data.content1}
        />
      </div>
      <div className="BusinessBodyCard">
        <BusinessBodyCard
          color="#249FDA"
          image={data.card_image2}
          text={data.content2}
        />
      </div>
      <div className="BusinessBodyCard">
        <BusinessBodyCard
          color="#3CA899"
          image={data.card_image3}
          text={data.content3}
        />
      </div>
      <div className="BusinessBodyCard">
        <BusinessBodyCard
          color="#B5A488"
          image={data.card_image4}
          text={data.content4}
        />
      </div>
      <div className="BusinessBodyCard">
        <BusinessBodyCard
          color="#FFBA33"
          image={data.card_image5}
          text={data.content5}
        />
      </div>
      <div className="BusinessBodyCard">
        <BusinessBodyCard
          color="#06476C"
          image={data.card_image6}
          text={data.content6}
        />
      </div>
      <div className="BusinessBodyCard">
        <BusinessBodyCard
          color="#6F8A86"
          image={data.card_image7}
          text={data.content7}
        />
      </div>
      <div className="BusinessBodyCard">
        <BusinessBodyCard color="#000000" image={bImg8} text={data.content8} />
      </div>
    </BusinessBodyCardContainer>
  );
}

const animation = keyframes`
   from { opacity: 0; filter: blur(10px); }
  to { opacity: 1; filter: blur(0px);}
`;

export const BusinessBodyCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  align-items: center;
  margin: 70px auto;
  gap: 3vw;
  opacity: 0;
  animation: ${animation} 1s 0.1s forwards;
  max-width: 1400px;
  padding: 0 20px;

  @media (min-width: 1600px) {
    gap: 2.5vw;
    margin: 90px auto;
    max-width: 1600px;
  }

  @media (max-width: 1599px) and (min-width: 1400px) {
    margin: 80px auto;
    max-width: 1400px;
  }

  @media (max-width: 1399px) and (min-width: 1200px) {
    margin: 70px auto;
    max-width: 1200px;
  }

  @media (max-width: 1199px) and (min-width: 900px) {
    margin: 60px auto;
    max-width: 1000px;
  }

  @media (max-width: 899px) and (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    margin: 50px auto;
    padding: 0 15px;
  }

  @media (max-width: 767px) and (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 3vw;
    margin: 40px auto;
    padding: 0 15px;
  }

  @media (max-width: 599px) and (min-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 4vw;
    margin: 35px auto;
    padding: 0 10px;
  }

  @media (max-width: 479px) and (min-width: 375px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 3vw;
    margin: 30px auto;
    padding: 0 10px;
  }

  @media (max-width: 374px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 2.5vw;
    margin: 25px auto;
    padding: 0 8px;
  }

  .BusinessBodyCard {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;
